import { Pagination } from '@mui/material';
import { SelectPicker } from 'rsuite';
import { useTranslation } from 'react-i18next';
import TableSelectedButton from '@widgets/tables/main/TableSelectedButton';
import { PER_PAGE } from '@utils/tables/params';

const perPageOptions = [10, 30, 50].map((v) => ({
  label: v,
  value: v,
}));

export default function CustomTablePagination({
  page,
  setPage,
  perPage,
  setPerPage,
  total,
  selected,
  filteredCount,
}) {
  const { t } = useTranslation();
  const safePerPage = Math.max(1, Number(perPage) || PER_PAGE);
  const pageCount = Math.max(1, Math.ceil((filteredCount || 0) / safePerPage));

  return (
    <div className="custom-pagination">
      <div className="custom-pagination-total">
        {selected && selected.length > 0 ? (
          <TableSelectedButton selected={selected} />
        ) : (
          <p>
            {filteredCount} <span className="secondary-text">{t('total')}</span>
          </p>
        )}
      </div>
      <Pagination
        count={pageCount}
        siblingCount={0}
        variant="outlined"
        shape="rounded"
        onChange={(_, value) => setPage(value)}
        page={page}
      />

      <div className="custom-pagination-rows">
        <p className="secondary-text">{t('per_page')}</p>
        <SelectPicker
          value={perPage}
          data={perPageOptions}
          placement="auto"
          searchable={false}
          cleanable={false}
          placeholder=""
          onChange={(value) => setPerPage(value)}
          style={{ width: 68 }}
        />
      </div>
    </div>
  );
}
